import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { TEST_ID } from '@/src/general/constants/testId'

import type { TStepperProps } from '../stepper.types'
import { BarStep } from './BarStep'

export const BarStepper = ({ totalSteps, currentStep, className }: TStepperProps): ReactNode => (
  <View testID={TEST_ID.ELEMENT.STEPPER} className={clsx('flex w-full flex-row gap-2', className)}>
    {Array.from({ length: totalSteps }, (_, index) => index).map((step) => (
      <BarStep key={step} isActive={currentStep > step} />
    ))}
  </View>
)
